import React from "react";
import { SFErrorOutlineIcon } from "../icons";
import { SFStack } from "../grid";
import SFTypography from "../typography";

const InputErrorLabel = ({ label }) => {
  return (
    <SFStack direction="row" alignItems="center" spacing={0.5}>
      <SFErrorOutlineIcon color="red400" size="small" />
      <SFTypography variant="body1" color="red400">
        {label}
      </SFTypography>
    </SFStack>
  );
};

export default InputErrorLabel;
